var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_8013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.77 56.63H10.67C9.47 56.63 8.5 55.66 8.5 54.46V6.67C8.5 5.47 9.47 4.5 10.67 4.5H36.73L51.93 19.7V54.45C51.93 55.65 50.96 56.62 49.76 56.62L49.77 56.63Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.74 4.5V19.7H51.94",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3966 33.733L30.6042 25.9407L22.7412 33.8037L30.5335 41.596L38.3966 33.733Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 21.23L18.04 29.09",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11 38.4399L35.25 46.2999",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6399 37.7L17.9399 46.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_8013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.44,
    height: 57.13,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.5d939eae39b46d48c853f0c873fb9c12.svg";
export { ForwardRef as ReactComponent };